import React, { useState, useEffect } from 'react'
import { Outlet, useLocation } from "react-router-dom"
import '../../styles/TracingInfoPage.css'

import * as vizSeaHouseMgt from '../../viz/SeaHouseMgt.jsx';

const DEBUG = true

export default function TracingInfoPage() {
  const [houseBl, setHouseBl] = useState('')
  const [tableData, setTableData] = useState([])
  const [searched, setSearched] = useState(false)

  const [data_shm_SearchList, setData_shm_SearchList] = useState([])
  
  // 가짜 데이터 (API 연동 시 여기만 바꾸면 됨)
  const mockData = [
    {
      no: 1,
      hbl: 'HKPUF02000224TS',
      etaBusan: '..',
      destination: 'HOCHIMINH, VIETNAM',
      vslName: 'SAWASDEE SIRIUS',
      voyage: '2404S',
      package: '1',
      weightVolume: '109.5 / 1.331',
      etd: '2024.03.24',
      eta: '2024.03.29',
      nf: 'P',
      pc: 'P',
    }
  ]

  function normalizeHouseBl(value) {
    const input = value.trim().toUpperCase()

    if (input.endsWith("TS")) {
      return input
    }

    if (input.endsWith("T")) {
      return input + "S"
    }

    return input + "TS"
  }

   const handleSearch = async (e) => {
    e.preventDefault()
    setSearched(true)

    // 실제 API 조회할 때 houseBl 보내서 fetch 하면 됨
    if (houseBl.trim() === '') {
      setTableData([])
      return
    }

    const nHouseBl = normalizeHouseBl(houseBl)
    console.log('nHouseBl:', nHouseBl)

    // 실제 API 호출
    await hbl_SearchList(nHouseBl.trim())
  }

  async function hbl_SearchList(hblValue){
      if (DEBUG) console.log('hbl_SearchList 시작')
      
      const args0 = {
          DOMAIN: "NTLK.ELVIS21.COM",
          OFFICE_CD: "NTLK",
          HBL_NO: hblValue,
          // BRANCH_CD: getOFFICE.user.BRANCH_CD,
          // FROM_RCP_YMD: _startDate.replace(/-/g,""),
          // TO_RCP_YMD: _endDate.replace(/-/g,""),
          // USER_ID: userInfo.username,
          // BLOCK_SEARCH_INS: false,
          // BLOCK_SEARCH_STA: true,
          // BLOCK_WORK_ID: false,
      }

      if (DEBUG) console.log('hbl_SearchList', args0);
      
      try {
          const retSeaHouseMgt = await vizSeaHouseMgt.hbl_SearchList(args0); // 비동기 함수 호출
          if (DEBUG) console.log('KEY_VALUE_PAIRS', retSeaHouseMgt.KEY_VALUE_PAIRS);
  
          if (retSeaHouseMgt.KEY_VALUE_PAIRS.TrxCode === "Y") {
            const list = retSeaHouseMgt.DataWG1?.retDataList || []
            console.log('list', list)
            
            const mappedList = list.map((doc, index) => ({
              no: index + 1,
              hbl: doc.hbl,                // 🔥 수정 포인트
              etaBusan: '',                   // 이 값은 서버에 없었음
              destination: doc.destination,
              vslName: doc.vslName,
              voyage: doc.voyage,
              package: doc.package,
              weightVolume: doc.weightVolume,
              etd: doc.etd,
              eta: doc.eta,
              nf: doc.nf,
              pc: convertPC(doc.pc),
            }))

            setTableData(mappedList)
          } else {
              if (DEBUG) console.log('hbl_SearchList error:', retSeaHouseMgt.KEY_VALUE_PAIRS.Status);
              // setSelectedOrderNumber('--SELECT--');
              // setDataGwgEgrMgt_List([]);
              setTableData([])
              setSearched(true)
              setData_shm_SearchList([])
              // setOrderNumbers(['--SELECT--']);
              return false
          }
      } catch (err) {
          if (DEBUG) console.error('hbl_SearchList catch', err);
          // setSelectedOrderNumber('--SELECT--');
          setTableData([])
          setSearched(true)
          setData_shm_SearchList([])
          // setOrderNumbers(['--SELECT--']);
          // setDataGwgEgrMgt_List([]);
          return false
      }
  }

  function convertPC(value) {
    if (!value) return value
    if (value.includes("PREPAID")) return "P"
    if (value.includes("COLLECT")) return "C"
    return ""
  }

  return (
    <div className="tracing-wrapper">
      <div className="tracing-box">
        <div className="tracing-title">Tracing Information</div>

        {/* 검색영역 */}
        <form className="tracing-search" onSubmit={handleSearch}>
          <label className="tracing-label">HOUSE B/L</label>
          <input
            className="tracing-input"
            value={houseBl}
            onChange={e => setHouseBl(e.target.value)}
            placeholder="Enter HOUSE B/L"
          />
          <button type="submit" className="tracing-search-btn">
            🔍 조회
          </button>
        </form>

        {/* 테이블 */}
        <div className="tracing-table-wrapper">
          <table className="tracing-table">
            <thead>
              <tr>
                <th>NO</th>
                <th>H B/L #</th>
                <th>ETA(BUSAN)</th>
                <th>DESTINATION</th>
                <th>2ND CONNECTING VSL NAME</th>
                <th>VOYAGE</th>
                <th>PACKAGE</th>
                <th>WEIGHT/VOLUME</th>
                <th>ETD</th>
                <th>ETA</th>
                <th>N/F</th>
                <th>P/C</th>
              </tr>
            </thead>

            <tbody>
              {/* 조회된 데이터 없음 */}
              {searched && tableData.length === 0 && (
                <tr>
                  <td colSpan="12">조회된 데이터가 없습니다.</td>
                </tr>
              )}

              {/* 조회된 데이터 있음 */}
              {searched && tableData.length > 0 &&
                tableData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.no}</td>
                    <td>{item.hbl}</td>
                    <td>{item.etaBusan}</td>
                    <td>{item.destination}</td>
                    <td>{item.vslName}</td>
                    <td>{item.voyage}</td>
                    <td>{item.package}</td>
                    <td>{item.weightVolume}</td>
                    <td>{item.etd}</td>
                    <td>{item.eta}</td>
                    <td>{item.nf}</td>
                    <td>{item.pc}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        {/* total count */}
        {searched && (
          <div className="tracing-footer">
            TOTAL B/L Count : <b>{tableData.length}</b>
          </div>
        )}
      </div>
    </div>
  )
}
